// extracted by css-extract-rspack-plugin
var _1 = "days-KgWu0Y";
var _2 = "times-UYdqOW";
export { _1 as "days", _2 as "times" }
